import { render, staticRenderFns } from "./SaveIODConfirmationModal.vue?vue&type=template&id=39ca1e1a&scoped=true"
import script from "./SaveIODConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SaveIODConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./SaveIODConfirmationModal.vue?vue&type=style&index=0&id=39ca1e1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca1e1a",
  null
  
)

export default component.exports